import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SearchListings from './pages/SearchListings';
import Home from './pages/Home';
import ApartmentDetails from "./components/ApartmentDetails";
import ResidentPortal from "./pages/ResidentPortal";



function App() {
  return (
    // <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API} onLoad={() => console.log('Maps API has loaded.')}>
      <Router>
        <Routes>
          <Route path="/" element={<Home/>}></Route>
          <Route path="/search-listings" element={<SearchListings/>}></Route>
          <Route path="/search-listings/apartments/:id" element={<ApartmentDetails/>}/>
          <Route path="/resident-portal" element={<ResidentPortal/>}></Route>
        </Routes>
      </Router>
    // </APIProvider>
  );
}

export default App;
